import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';

@Component({
  selector: 'table-column-icon',
  templateUrl: './table-column-icon.component.html',
  standalone: false,
})
export class TableColumnIconComponent<T> implements OnChanges {
  @Input() element: T;

  @Input() iconName?: string | UnaryFunction<T, string>;

  @Input() cssClass?: string | UnaryFunction<T, string>;

  @Input() tooltip?: string | UnaryFunction<T, string>;

  @Input() noSdxIcon?: boolean | UnaryFunction<T, boolean>;

  @Input() hidden?: boolean | UnaryFunction<T, boolean>;

  @Input() tooltipClass?: boolean | UnaryFunction<T, boolean>;

  @Input() disabled: boolean | UnaryFunction<T, boolean> = false;

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = false;

  ngOnChanges(changes: SimpleChanges): void {
    const { iconName, cssClass, tooltip, tooltipClass, noSdxIcon, disabled, hidden } = changes;
    if (iconName && typeof this.iconName === 'function') {
      const getIconName = this.iconName;
      this.iconName = getIconName(this.element);
    }
    if (cssClass && typeof this.cssClass === 'function') {
      const getCss = this.cssClass;
      this.cssClass = getCss(this.element);
    }
    if (tooltip && typeof this.tooltip === 'function') {
      const getTooltip = this.tooltip;
      this.tooltip = getTooltip(this.element);
    }
    if (tooltipClass && typeof this.tooltipClass === 'function') {
      const getTooltipClass = this.tooltipClass;
      this.tooltipClass = getTooltipClass(this.element);
    }
    if (noSdxIcon && typeof this.noSdxIcon === 'function') {
      const getNoSdxIcon = this.noSdxIcon;
      this.noSdxIcon = getNoSdxIcon(this.element);
    }
    if (disabled && typeof this.disabled === 'function') {
      const getDisabled = this.disabled;
      this.disabled = getDisabled(this.element);
    }
    if (hidden && typeof this.hidden === 'function') {
      const getHidden = this.hidden;
      this.hidden = getHidden(this.element);
    }
  }
}
